import { useStage } from '@/pages/contextProvider';
import { EB_HOME_URL } from './constants';

export type UrlType =
  | 'EB_HOME_URL'
  | 'LOGIN_URL'
  | 'SIGN_UP_URL'
  | 'RESET_PASSWORD_URL'
  | 'MY_TICKETS_URL'
  | 'HELP_CENTER_URL'
  | 'HELP_CENTER_YOUR_TICKETS'
  | 'HELP_CENTER_DUPLICATE_CHARGES'
  | 'CONTACT_ORGANIZER_URL'
  | 'SEARCH_EVENTS_URL'
  | 'AUTH0_URL';

export const useEventbriteUrl = (urlType: UrlType) => {
  const stage = useStage();
  const baseUrl = EB_HOME_URL[stage];
  const helpUrl = `${baseUrl}/help/en-us`;

  const urls: Record<UrlType, string | undefined> = {
    EB_HOME_URL: baseUrl,
    SIGN_UP_URL: `${baseUrl}/signin/signup/`,
    LOGIN_URL: `${baseUrl}/signin/?referrer=%2Fmytickets%2F`,
    RESET_PASSWORD_URL: `${baseUrl}/reset-password`,
    MY_TICKETS_URL: `${baseUrl}/mytickets`,
    HELP_CENTER_URL: helpUrl,
    HELP_CENTER_YOUR_TICKETS: `${helpUrl}/articles/319355/where-are-my-tickets/`,
    HELP_CENTER_DUPLICATE_CHARGES: `${helpUrl}/articles/103000/why-was-i-charged-multiple-times-for-an-event/`,
    CONTACT_ORGANIZER_URL: `${helpUrl}/articles/647151/how-to-contact-the-event-organizer/`,
    SEARCH_EVENTS_URL: `${baseUrl}/d/local/events/`,
    AUTH0_URL: `${baseUrl}/api/v3/pre_auth/`,
  };
  const url = urls[urlType];
  if (!url) {
    throw new Error(`Unknown urlType: ${urlType}`);
  }
  return url;
};
